(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const create = ({ drawer, trigger, triggers, backdrop, initialFocus } = {}) => {
    const triggerList = [...new Set(
      [...(Array.isArray(triggers) ? triggers : []), trigger].filter(Boolean)
    )];
    const primaryTrigger = triggerList[0];
    if (!drawer || !primaryTrigger || !backdrop) return null;

    let returnFocus = primaryTrigger;
    let isOpen = false;

    const setExpanded = value => {
      triggerList.forEach(button => button.setAttribute('aria-expanded', value));
    };

    const focusableElements = () => [...drawer.querySelectorAll(focusableSelector)]
      .filter(element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0);

    const close = () => {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      setExpanded('false');
      document.body.classList.remove('right-drawer-open');
      backdrop.hidden = true;
      drawer.dispatchEvent(new CustomEvent('rightdrawer:close'));
      (returnFocus || primaryTrigger).focus({ preventScroll: true });
    };

    const open = () => {
      if (isOpen) return;
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : primaryTrigger;
      drawer.dispatchEvent(new CustomEvent('rightdrawer:beforeopen'));
      isOpen = true;
      backdrop.hidden = false;
      document.body.classList.add('right-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      setExpanded('true');
      requestAnimationFrame(() => {
        if (!isOpen) return;
        drawer.classList.add('is-open');
        backdrop.classList.add('is-open');
        (initialFocus?.() || focusableElements()[0])?.focus();
      });
    };

    triggerList.forEach(button => button.addEventListener('click', open));
    backdrop.addEventListener('click', close);
    drawer.querySelectorAll('[data-right-drawer-close]').forEach(button => button.addEventListener('click', close));
    document.addEventListener('keydown', event => {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const api = { open, close, get isOpen() { return isOpen; } };
    drawer._ascRightDrawer = api;
    return api;
  };

  window.AscRightDrawer = { create };
})();
